/** What the staff screens call an instructor; contracts, documents and payouts keep the real name. */
export function displayName(data) {
    return `${data.nickname || data.name} ${data.surname}`.trim();
}
/** Jan „Honza“ Novák, or just the real name when there is no nickname to add. */
export function nameWithNickname(data) {
    if (!data.nickname || data.nickname === data.name) {
        return `${data.name} ${data.surname}`.trim();
    }
    return `${data.name} „${data.nickname}“ ${data.surname}`.trim();
}
